// Lookbook Manage Flow
export const LOOKBOOK_MANAGE_FLOW_SHOW_PREVIEW = 'LOOKBOOK_MANAGE_FLOW_SHOW_PREVIEW';
export const LOOKBOOK_MANAGE_FLOW_SET_PROP = 'LOOKBOOK_MANAGE_FLOW_SET_PROP';
export const LOOKBOOK_MANAGE_FLOW_SET_DATA = 'LOOKBOOK_MANAGE_FLOW_SET_DATA';
export const LOOKBOOK_MANAGE_FLOW_SET_UNSAVED_CHANGES = 'LOOKBOOK_MANAGE_FLOW_SET_UNSAVED_CHANGES';
export const LOOKBOOK_MANAGE_FLOW_APPLY_STOCK = 'LOOKBOOK_MANAGE_FLOW_APPLY_STOCK';
export const LOOKBOOK_MANAGE_FLOW_SET_VARIANT_IMAGE = 'LOOKBOOK_MANAGE_FLOW_SET_VARIANT_IMAGE';
export const LOOKBOOK_MANAGE_FLOW_CLEAR = 'LOOKBOOK_MANAGE_FLOW_CLEAR';
export const LOOKBOOK_MANAGE_FLOW_SET_ERRORS = 'LOOKBOOK_MANAGE_FLOW_SET_ERRORS';
export const LOOKBOOK_MANAGE_FLOW_CLEAR_ERROR = 'LOOKBOOK_MANAGE_FLOW_CLEAR_ERROR';
export const LOOKBOOK_MANAGE_FLOW_CLEAR_ERRORS = 'LOOKBOOK_MANAGE_FLOW_CLEAR_ERRORS';